import { connect } from 'react-redux';
import actions from 'actions/InCall/InCallVideo';
import { inlinePresentationSelector } from 'selectors/call';
import Turtle from 'components/Turtle/Turtle';
import _get from 'lodash/get';
import { callSelectors } from '@lifesize/nucleus';

const mapActionCreators = dispatch => ({
  handleDrag: (e, ui) => dispatch(actions.handleDrag(e, ui)),
  turtleDragStart: () => dispatch(actions.turtleDragStart()),
  turtleDragStop: () => dispatch(actions.turtleDragStop()),
});

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const hasVideo = _get(state, 'app.inCallVideo.shouldDisplayPrimaryVideo') && activeCall.hasIncomingVideo;
  const videoLayout = _get(state, 'app.inCallVideo.videoLayout') || {};

  const inlinePresentation = inlinePresentationSelector(state);
  const positionX = _get(videoLayout, 'container.width') || 0;
  const turtlePosition = {
    x: (positionX * videoLayout.splitPosition) - videoLayout.turtleHalfWidth,
    y: videoLayout.turtleYOffset
  };
  const isMinimized = _get(state, 'app.inCallVideo.isMinimized');
  const isDragging = _get(state, 'app.inCallVideo.isDragging');
  const visible = inlinePresentation && hasVideo && !isMinimized;

  return ({
    turtlePosition,
    videoLayout,
    isDragging,
    visible
  });
};

export default connect(mapStateToProps, mapActionCreators)(Turtle);
